exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jumbotron-fill {\r\n  padding: 0;\r\n}\r\n\r\n.jumbotron {\r\n   margin-bottom: 0;\r\n}\r\n.logo{\r\n  position: absolute;\r\n  bottom: 20px;\r\n  left: 30px;\r\n  z-index: 100;\r\n  opacity: 0.4;\r\n\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/main/slider/slider.component.css
// module id = 310
// module chunks = 1